import React from 'react';
import './AutocompleteList.css';

/**
 * Presentational list for autocomplete results.
 *
 * @param {Object} props
 * @param {Array} props.items
 * @param {string} props.id
 * @param {Function} props.getItemKey
 * @param {Function} props.renderItem
 * @param {Function} props.onSelect
 * @param {boolean} props.loading
 * @param {string} props.error
 * @param {string} props.emptyMessage
 * @param {string} props.ariaLabel
 */
export default function AutocompleteList({
  items = [],
  id,
  getItemKey = (_item, index) => index,
  renderItem = item => String(item),
  onSelect,
  loading = false,
  error = '',
  emptyMessage = '',
  ariaLabel = 'Suggestions',
}) {
  const hasItems = items.length > 0;

  return (
    <div className="ac-list" id={id}>
      {loading && (
        <p className="ac-list-status" role="status">
          Loading suggestions...
        </p>
      )}
      {!loading && error && (
        <p className="ac-list-status ac-list-error" role="alert">
          {error}
        </p>
      )}
      {!loading && !error && !hasItems && emptyMessage && (
        <p className="ac-list-status" role="status">
          {emptyMessage}
        </p>
      )}
      {!loading && !error && hasItems && (
        <ul aria-label={ariaLabel}>
          {items.map((item, index) => (
            <li key={getItemKey(item, index)}>
              <button
                type="button"
                className="ac-list-option"
                onClick={() => onSelect?.(item)}
              >
                {renderItem(item)}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
